import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error2",
  "use": "error2-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"error2\">\n<circle cx=\"7.00065\" cy=\"7.00016\" r=\"6.41667\" fill=\"#E53935\" />\n<path d=\"M4.7168 4.71729L9.28201 9.2825\" stroke=\"#350A09\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M9.28201 4.71729L4.7168 9.2825\" stroke=\"#350A09\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol